import gsap from 'gsap';

export default class Slider {
    static init() {
      	// Scroll
        const elts = document.querySelectorAll('.slider');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                gsap.to(
                    elt.querySelectorAll('.slider__item'),
                    {
                        xPercent: -100,
                        duration: 20,
                        repeat: -1,
                        ease: 'linear',
                    }
                );
            });
        }
    }
}